import b2bActionTypes from '../constants/action-types';

const b2bState = {
  keys: null,
  showDeactivateKeyModal: false,
  selectedKey: null,
  deactivateKeyInProgress: false,
  generateKeyInProgress: false,
};

export const b2bReducer = (state = b2bState, payload) => {
  switch (payload.type) {
    case b2bActionTypes.HANDLE_SUCCESS_GET_KEYS:
      return { ...state, keys: payload.data };
    case b2bActionTypes.TOGGLE_DEACTIVATE_KEY_MODAL:
      return { ...state, showDeactivateKeyModal: payload.data.show, selectedKey: payload.data.key };
    case b2bActionTypes.DEACTIVATE_KEY_IN_PROGRESS:
      return { ...state, deactivateKeyInProgress: payload.data };
    case b2bActionTypes.GENERATE_KEY_IN_PROGRESS:
      return { ...state, generateKeyInProgress: payload.data };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/main/b2b/reducers/b2b-reducer.js